export default "__VITE_ASSET__B8vybiX4__";